import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [{ path: 'leads', lazy: async () => ({ Component: (await import('./LeadsPage')).LeadsPage }) }];
